import * as Backbone from "backbone";
import ViewStoreModule from "util/ViewStoreModule";
import _ from "lodash";
import {confirmJN} from 'module/ConfirmDialog/component/ConfirmDialogContainer';
import {generateErrorHandler} from 'module/ConfirmDialog/compat/JQueryErrorHandlers';

export const FavSelectView = Backbone.View.extend({
	className: 'FavSelectView',
	events: {
		'click .FavSelect': 'select',
		'click .FavDeselect': 'deselect',
		'click .FavActivate': 'activate',
		'click .FavDeleteStoreEntry': 'deleteEntry',
	},
	initialize: function (options) {
		this.selpan = options.selpan;
		this.listenTo(this.selpan.status, 'change:favKey', this.render);
		this.listenTo(ViewStoreModule.entries, 'reset add remove', this.render);
		this.render();
	},
	select: function (evt) {
		let key = this.getKeyFromEvent(evt);
		this.selpan.saveAllFav();
		this.selpan.status.set({favKey: key});
	},
	deselect: function () {
		this.selpan.saveAllFav();
		this.selpan.status.set({favKey: undefined});
	},
	deleteEntry: function (evt) {
		let view = this.selpan.getFavRemoteStoreViewName();
		let key = this.getKeyFromEvent(evt);
		if (key) {
			confirmJN('Wollen Sie den Favoriten "' + key + '" wirklich löschen?').then(function () {
				let model = ViewStoreModule.entries.findWhere({
					view: view,
					key: key,
				});
				let storno = model.destroy({dataType: 'text'});
				if (storno) {
					storno.fail(generateErrorHandler('Fehler beim löschen des Favoriten "' + key + '"'));
				}
			});
		}
	},
	getKeyFromEvent: function (evt) {
		return this.$(evt && evt.target).closest("[data-id]", this.el).attr('data-id');
	},
	// language=HTML
	template: _.template('<% _.each(models, function(m){ %>\n<div data-id="<%= m.attributes.key %>">\n\t<div class="FavDeleteStoreEntry MenuItem MenuButton MenuRight"><i class="fa fa-trash"></i></div>\n\t<div class="FavSelect MenuItem">\n\t\t<div class="MenuLabel"><%= m.attributes.key %></div>\n\t</div>\n</div>\n<% }) %>\n<% if(showDeselect){ %>\n<div>\n\t<div class="FavDeselect MenuItem">\n\t\t<div class="MenuIcon MenuInline"><i class="fa fa-star-o"></i></div>\n\t\t<div class="MenuLabel MenuInline">Alle</div>\n\t</div>\n</div>\n<% } %>\n'),
	render: function () {
		let viewName = this.selpan.getFavRemoteStoreViewName();
		let active = this.selpan.status.get('favKey');
		let models = ViewStoreModule.entries.filter(function (m) {
			return m.get('view') === viewName && m.get('key') !== active;
		});
		this.$el.html(this.template({
			models: _.sortBy(models, m => m.get('key')),
			showDeselect: !!active,
		}));
	},
});
